(() => {
  if (customElements.get('kd-tag-video')) return;

  customElements.define('kd-tag-video', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;

      this.controller = new AbortController();
      const { signal } = this.controller;
      let pausedByUser = false;
      let pausedByHover = false;
      const play = () => video.play().catch(() => {});
      const updateLabel = () => {
        button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      };

      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        pausedByHover = !video.paused;
        video.pause();
      }, { signal });
      this.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        if (pausedByHover && !pausedByUser) play();
        pausedByHover = false;
      }, { signal });
      button.addEventListener('click', () => {
        pausedByUser = !video.paused;
        pausedByHover = false;
        if (pausedByUser) video.pause();
        else play();
      }, { signal });
      video.addEventListener('play', updateLabel, { signal });
      video.addEventListener('pause', updateLabel, { signal });
      button.hidden = false;
      updateLabel();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
